/**
 * /about - "Software and support dates" for admin.mypcb.com (0.51.0).
 *
 * This portal's own packages (embedded at build time) plus the live GET /api/health/about of the
 * two backends it talks to on every visit: pcb-retail-api (Retail and Shared areas) and
 * pcb-innovation-api (the Hub area). Contract: docs/standards/about-dependencies-contract.md.
 */

import { useMemo } from 'react';
import { AboutDependencies, type AboutBackend } from '@retail-ops/about-panel';
import { useApiClient } from '@/contexts/ApiClientContext';
import { HUB_API_BASE } from '@/platforms/hub/hubApi';
import { APP_NAME, APP_VERSION } from '@/constants/version';

async function fetchJson(url: string): Promise<unknown> {
  // pcb-innovation-api leaves /api/health* open (as its /api/health), so no token is sent.
  const resp = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}

export function AboutPage(): JSX.Element {
  const client = useApiClient();
  const backends = useMemo<AboutBackend[]>(
    () => [
      { label: 'Server: pcb-retail-api (Retail and Shared)', load: () => client.health.about() },
      { label: 'Server: pcb-innovation-api (Innovation Hub)', load: () => fetchJson(`${HUB_API_BASE}/health/about`) },
    ],
    [client],
  );
  return (
    <div className="pcb-about-page">
      <h2 className="pcb-about-page__title">About {APP_NAME}</h2>
      <p className="pcb-about-page__intro">
        Version {APP_VERSION}. Every piece of software this portal and its servers run, with the date its
        publisher stops supporting it.
      </p>
      <AboutDependencies backends={backends} />
    </div>
  );
}

export default AboutPage;
